export const codeInputPlaceholder = (
  functionName: string,
  functionArgs: string | string[],
) => {
  const stringArgs = Array.isArray(functionArgs)
    ? functionArgs.join(', ')
    : functionArgs;

  const functionDefinition = `def ${functionName}(${stringArgs})`;

  return `${functionDefinition}:\n  # Add your function definition here.\n  # You can optionally return a string that will be fed back to the LLM.\n  pass`;
};
